import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { TPVServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { PrintServices } from "../../../../services/printServices";
import { StockServices } from "../../../../stock/services";
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../../services/analyticsServices';
import { TpvLoaderPage } from '../../../tpv-loader/tpv-loader';
import { OrdersLoaderPage } from '../../../../orders/orders-loader/orders-loader';

/**
 * Generated class for the TpvTicketSelectedPayIndvPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-ticket-selected-pay-indv',
  templateUrl: 'tpv-ticket-selected-pay-indv.html',
})
export class TpvTicketSelectedPayIndvPage {

  ticket_elements: any = Array();
  indv_amount = 0;
  indv_type = '';//indv_elements
  indv_elements_arrow = false;
  indv_amount_arrow = false;
  indv_type_selected = '';
  same_tax: boolean = true;
  selected_list: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    private alertCtrl: AlertController,
    public printServices: PrintServices,
    public stockServices: StockServices,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public analyticsServices: AnalyticsServices) {
    this.tpvServices.ticket_print = 'indv';
    this.selected_list = this.tpvServices.listSelectedTicket('name', this.globals.objectToArray(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.list))[0]
  }
  /**********************************************************/
  /*                          INIT                          */
  /**********************************************************/

  ionViewDidLoad() {
    this.ticket_elements = this.globals.objectToArray(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.list);
    this.indv_type = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].payment_individual;
    this.indv_type_selected = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].payment_individual;
    //check if elements all same tax
    for (let element of this.ticket_elements) {
      if (!element.tax) {
        element.tax = this.globals.RESTAURANT_TAX;
      }
      if (element.tax && element.tax != this.globals.RESTAURANT_TAX) {
        this.same_tax = false;
      }
    }
  }

  /**********************************************************/
  /*                          END                           */
  /**********************************************************/

  ionViewWillUnload() {
    this.tpvServices.ticket_print = 'normal';
  }

  /**********************************************************/
  /*                       FUNCIONES                        */
  /**********************************************************/

  calculate(total, pay) {
    var _return = pay - total;
    if (_return > 0) {
      return _return
    } else {
      return 0;
    }
  }

  insertArraySelected(element, index) {
    this.indv_type = 'indv_elements';
    this.changeState(index, 'selected');
    //como los elementos son individuales pones 1 unidad para que no de problemas al cobrar y calcule bien
    this.ticket_elements[index]['units'] = 1;
  }

  changeState(index, state) {
    this.ticket_elements[index]['state_indv'] = state;
  }

  async pay(payment_type) {
    //limita a no cobrar mas de una vez y cree errores 
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cobrando')
    });
    loadingPopup.present();
    //preseleccionamos el tipo de impresion de ticket (individual)
    this.tpvServices.ticket_print = 'indv';
    //creamos lista segun el tipo de pago individual
    var _array = Array();
    if (this.indv_type === 'indv_elements') {
      //Modificamos los valors de selectes a pay. Creamos un array para crear el nuevo ticket
      this.tpvServices.totalTicketIndvNoTax(this.ticket_elements, this.globals.RESTAURANT_TAX);
      for (let key in this.ticket_elements) {
        //let value = this.ticket_elements[key];
        if (this.ticket_elements[key].state_indv == 'selected') {
          _array.push(this.ticket_elements[key]);
          if (this.ticket_elements[key].type == 'menu') {
            this.globals.dataSet('sales_menu', this.ticket_elements[key].name, '', this.ticket_elements[key].price, '');
          } else if (this.ticket_elements[key].type == 'dish') {
            this.globals.dataSet('sales_dish', this.ticket_elements[key].name, '', this.ticket_elements[key].price, '');
          } else {
            this.globals.dataSet('sales_product', this.ticket_elements[key].name, '', this.ticket_elements[key].price, '');
          }
        }
      }
      //Clean array
      for (let key in _array) {
        delete _array[key].variation_array;
        delete _array[key].variation_add;
      }
    } else {
      //Añadimos elemento cobro individual con la cantidad especificada en el input
      _array.push({
        name: this.translate.instant("general-cobro-individual"),
        price: this.indv_amount,
        delete: false,
        count: true,
        type: '',
        uid_element: '',
        waiter: this.globals.waiter,
        waiter_uid: this.globals.waiter_uid,
        units: 1,
        variation: [],
        tags: [],
        type_unit: 'ud',
        tax: this.globals.RESTAURANT_TAX
      });
    }
    //get ticket number
    await this.tpvServices.getTicketNumber(this.globals.restaurant_uid, this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].cash_uid);
    //añadimos el total segun el tipo de pago individual 
    var _amount = 0;
    if (this.indv_type === 'indv_elements') {
      _amount = this.tpvServices.totalTicketIndv(this.ticket_elements);
    } else {
      _amount = this.indv_amount;
    }
    //añadimos la fecha
    var _date = new Date();
    //openCashDrawer
    if (payment_type == 'cash') {
      this.printServices.openCashDrawerByType();
    }
    //insertamos el ticket
    this.tpvServices.afs.collection('tickets').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      amount: _amount,
      tax: this.globals.RESTAURANT_TAX,
      cash_static: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].cash_static,
      cash_uid: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].cash_uid,
      date: _date,
      list: _array,
      number: this.tpvServices.ticket_num_return,
      payment: true,
      payment_type: payment_type,
      waiter: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.waiter,
      waiter_uid: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.waiter_uid,
      type: this.tpvServices.selected_type,
      closed: false,
      pending: false,
      table_uid: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID,
      room: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].room,
      table: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].name,
    }).then(value => {
      //actualizamos en la mesa el tipo de pago seleccionado para bloquear la mesa hasta ser pagada
      //actualizamos la cantidad pagada individualmente en la mesa para controlar el cobro
      //
      this.tpvServices.afs.collection('tables').doc(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID).update({
        payment_individual: this.indv_type,
        amount_paid: this.globals.ifNumEmpty(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].amount_paid) + _amount,
      });
      this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].payment_individual = this.indv_type;
      this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].amount_paid = this.globals.ifNumEmpty(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].amount_paid) + _amount;
      this.indv_type_selected = this.indv_type;
      //
      var extra: any =
      {
        'ticket_open': moment(new Date(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.created_at.toDate())).format("YYYY/MM/DD HH:mm:ss").toString(),
        'ticket_close': moment(new Date()).format("YYYY/MM/DD HH:mm:ss").toString(),
        'persons': 1,
        'room': this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].room,
        'waiter': this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.waiter,
        'discount': false,
        'discount_type': '',
        'discount_price': 0,
      };
      //dataset
      this.globals.dataSet('sales_ticket', _amount, '', JSON.stringify(extra), '');

      //prepare print
      this.tpvServices.total_ticket_indv_print = _amount;
      this.tpvServices.subtotal_ticket_indv_print = this.globals.createSubTotal(_amount, this.globals.RESTAURANT_TAX);
      this.tpvServices.ticket_print_ind = _array;
      this.tpvServices.ticket_print_ind_number = this.tpvServices.ticket_num_return;
      this.tpvServices.ticket_print_ind_date = _date;

      this.tpvServices.ticket_print_ind_waiter = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.waiter;
      this.tpvServices.ticket_print_ind_room = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].room;
      this.tpvServices.ticket_print_ind_table = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].name;

      //netejem pantalla
      this.tpvServices.deleteKeyboard();
      this.indv_amount = 0;
      //SALES_SALES ELEMENT
      let elements = [];
      for (let element of _array) {
        //comprobamos que el elemento no esté eliminado
        if (!element.delete) {
          var _element = {
            "name": element.name,//nom del producto/plato/menu
            "uid_element": element.uid_element,//uid el producto/plato/menu
            "sales": element.price,//precio 
            "type": element.type,//que tipo de elemento es producto/plato/menu
            "foodcost": 0,//foodcost
            'waiter': element.waiter,
            "half": "",
          };
          if (element.name.includes('<b> M.</b>')) {
            _element.half = 'half'
          } else if (element.name.includes('<b> P.</b>')) {
            _element.half = 'tap'
          }
          elements.push(_element)
        }
      }
      //
      var sales_elements = {
        "uid": this.globals.restaurant_uid,//uid_restaurant
        "uid_doc": value.id,//uid del ticket
        "date": new Date(),//date
        "list": elements,
        "type": "sales_elements",
      };
      var stock = {
        "elements": elements,
        "uid": this.globals.restaurant_uid,
        "date": new Date(),
        "type": "stock",
        "comment": "",
        "type_type": "TICKET",
        "delivery_uid": null
      };
      //insert _data
      this.analyticsServices.sendSalesElements(sales_elements);
      this.analyticsServices.sendStock(stock);

      //SALES_SALES SALE
      var sales_sales = {
        'uid': this.globals.restaurant_uid,
        'uid_doc': value.id,
        'date': _date,
        'sales': _amount,
        'type': "sales_sales",
        'type_type': payment_type,
        'persons': 1,
        'zone': this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].room,
        'discount_type': null,
        'discount': null,
        'foodcost': 0,
        'tip': 0,
        'app_section': 'tpv',
        'text': this.tpvServices.ticket_num_return,
        'waiter': this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.waiter
      }
      this.analyticsServices.sendSalesSales(sales_sales);
      //SALES_SALES
      loadingPopup.dismiss();

      //antes de imprimir cargamos en la selected list los elementos cobrados
      this.selected_list = this.tpvServices.listSelectedTicket('name', this.tpvServices.ticket_print_ind)[0];

      let alert = this.alertCtrl.create({
        title: this.translate.instant('general-imprimir-ticket'),
        message: this.translate.instant('instant-seguro-quieres-imprimir-ticket'),
        buttons: [
          {
            text: this.translate.instant('general-no'),
            role: 'cancel',
            handler: () => {
              for (let key in this.ticket_elements) {
                //let value = this.ticket_elements[key];

                if (this.ticket_elements[key].state_indv == 'selected') {
                  this.ticket_elements[key].state_indv = 'pay';
                }
                //clean
                this.tpvServices.cleanTicketIndvSelectedArray();
                this.tpvServices.ticket_print_ind = [];
                _array = [];
                this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.number = null;
              }
            }
          },
          {
            text: this.translate.instant('general-si'),
            handler: () => {

              if (this.globals.restaurant.printer_type == 'native') {
                this.globals.print_content = document.getElementById('print_list_ticket_indv');
                this.printServices.printNow('print_list_ticket_indv');
                //clean
                this.tpvServices.ticket_print_ind = [];
                _array = [];
                this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.number = null;
              } else {
                this.printServices.prepareTicket(
                  this.tpvServices.listSelectedTicket('name', this.tpvServices.ticket_print_ind)[0]
                  , this.tpvServices.ticket_print_ind_date
                  , this.tpvServices.subtotal_ticket_indv_print
                  , this.tpvServices.total_ticket_indv_print
                  , this.tpvServices.calculateIva(this.tpvServices.total_ticket_indv_print, this.tpvServices.subtotal_ticket_indv_print, this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket)
                  , this.tpvServices.ticket_print_ind_waiter
                  , this.tpvServices.ticket_print_ind_room
                  , this.tpvServices.ticket_print_ind_table
                  , this.globals.restaurant.tickets.footer
                  , 'tpv'
                  , this.tpvServices.ticket_print_ind_number
                  , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket
                  , this.globals.restaurant.printer_type
                  , false
                  , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.notes || '');
                //clean
                this.tpvServices.ticket_print_ind = [];
                _array = [];
                this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.number = null;
              }


              for (let key in this.ticket_elements) {
                //let value = this.ticket_elements[key];

                if (this.ticket_elements[key].state_indv == 'selected') {
                  this.changeState(key, 'pay');
                  //this.ticket_elements[key].state_indv = 'pay';
                }
                this.tpvServices.cleanTicketIndvSelectedArray();

              }
            }
          }
        ]
      });
      alert.present();

    });
  }

  finishTicket() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-finalizar-ticket'),
      message: this.translate.instant('instant-seguro-quieres-finalizar-ticket'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            //clean indv vars
            this.tpvServices.afs.collection('tables').doc(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID).update({
              amount_paid: 0,
              payment_individual: null,
            });
            //cancel table
            this.tpvServices.cancelTicket('clean');
            if (!this.tpvServices.is_in_order) {
              this.globals.side_menu_active = 'tpv';
              this.navCtrl.setRoot(TpvLoaderPage);
            } else {
              this.globals.side_menu_active = 'order';
              this.navCtrl.setRoot(OrdersLoaderPage);
            }
            /*this.navCtrl.pop();
            this.navCtrl.pop();
            this.navCtrl.pop();*/
          }
        }
      ]
    });
    alert.present();
  }

  totalNoPay() {
    var _sum = 0;
    for (let key in this.ticket_elements) {
      _sum = Number(_sum) + Number(this.ticket_elements[key].price);
      for (let key_var in this.ticket_elements[key].variation) {
        _sum += Number(this.ticket_elements[key].variation[key_var].price);
      }
    }

    _sum += this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.tip;

    return Number(_sum);


  }

  totalPay() {
    /*
    var _sum = 0;
    for (let key in this.ticket_elements) {
      if (this.ticket_elements[key].state_indv == 'pay') {
        _sum = Number(_sum) + Number(this.ticket_elements[key].price);
        for (let key_var in this.ticket_elements[key].variation) {
          _sum += Number(this.ticket_elements[key].variation[key_var].price);
        }
      }
    }*/
    var amount = 0;
    if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].amount_paid) {
      amount = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].amount_paid;
    }



    return Number(amount);
  }

  delete(index) {
    this.changeState(index, '');
  }


  selectType(type) {
    var arrow: any;
    if (type === 'indv_elements') {
      arrow = document.getElementById("indv_elements_arrow");
      this.indv_elements_arrow = !this.indv_elements_arrow;
    } else {
      arrow = document.getElementById("indv_amount_arrow");
      this.indv_amount_arrow = !this.indv_amount_arrow;
    }

    if (type === 'indv_elements' && this.indv_elements_arrow) {
      arrow.classList.remove("mdi-arrow-down");
      arrow.classList.add('mdi-arrow-up');
      this.indv_type = type;
    } else if (type === 'indv_elements' && !this.indv_elements_arrow) {
      arrow.classList.remove("mdi-arrow-up");
      arrow.classList.add('mdi-arrow-down');
      this.indv_type = '';
    } else if (type === 'indv_amount' && this.indv_amount_arrow) {
      arrow.classList.remove("mdi-arrow-down");
      arrow.classList.add('mdi-arrow-up');
      this.indv_type = type;
    } else if (type === 'indv_amount' && !this.indv_amount_arrow) {
      arrow.classList.remove("mdi-arrow-up");
      arrow.classList.add('mdi-arrow-down');
      this.indv_type = '';
    }
  }

  onchangeAmount() {
    this.indv_type = 'indv_amount';
    //reset elements selected

    for (let key in this.ticket_elements) {
      if (this.ticket_elements[key].state_indv == 'selected') {
        this.changeState(key, '');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-pay-indv/tpv-ticket-selected-pay-indv.ts